import * as React from 'react';
import { ItemType } from '../../classes/item-type';
import FilterPageHeader from './filter-page-header';

interface IFilterPageHeaderContainerProps {
    itemType: ItemType;
    subscriptionFilterPageHeaderTitle: string;
    subscriptionFilterPageHeaderMessage: string;
    filterPageHeaderTitle: string;
    filterPageHeaderMessage: string;
}

class FilterPageHeaderContainer extends React.PureComponent<IFilterPageHeaderContainerProps, any>{
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.itemType === ItemType.Flex
            || this.props.itemType === ItemType.Fixed
            || this.props.itemType === ItemType.Super) {
            return (
                <FilterPageHeader title={this.props.subscriptionFilterPageHeaderTitle}
                    message={ this.props.subscriptionFilterPageHeaderMessage }
                />
            );
        } else if (this.props.filterPageHeaderTitle.length > 0 || this.props.filterPageHeaderMessage.length > 0) {
            return (
                <FilterPageHeader title={this.props.filterPageHeaderTitle}
                    message={this.props.filterPageHeaderMessage}
                />
            );
        } else return null;
    }
}

export default FilterPageHeaderContainer;